import { createApp } from 'vue'
import App from './App.vue'
import { setupI18n } from './locales'
import { setupAssets, setupScrollbarStyle } from './plugins'
import { setupStore } from './store'
import { setupRouter } from './router'
import 'virtual:svg-icons-register'; // 引入虚拟的 svg 图标模块
import IconSvg from '@/components/common/IconSvg/index.vue';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'




async function bootstrap() {
  const app = createApp(App)

	for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
		app.component(key, component)
	}

  // 全局注册 SvgIcon 组件
  app.component('IconSvg', IconSvg);
  setupAssets()

  setupScrollbarStyle()

  setupStore(app)

  setupI18n(app)

	app.use(ElementPlus)

  await setupRouter(app)

  app.mount('#app')
}

bootstrap()
